import comp from "./StandardRubricView";
export default comp;
